import Vue from 'vue'

const state = Vue.observable({
  isLoading: true,
})

export default {
  getState() {
    return state
  },
  setLoading(loading) {
    state.isLoading = loading
  },
}
